import { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { teamData } from "../../data/teamData";

const TeamSection = () => {
  // 👉 hiển thị 6 người mỗi trang cho đều 2 hàng
  const itemsPerPage = 3;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(teamData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const selectedTeams = teamData.slice(startIndex, startIndex + itemsPerPage);

  return (
    <section className="team-section fix section-padding">
      <div className="container">
        <div className="row g-4">
          {selectedTeams.map((member, idx) => (
            <div
              key={member.id}
              className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
              data-wow-delay={`${0.2 + idx * 0.1}s`}
            >
              <div
                className={`team-card-items text-center mt-0 ${
                  idx === 1 ? "active" : ""
                }`}
              >
                <div className="team-image">
                  <img
                    src={member.image}
                    alt={member.name}
                    loading="lazy"
                  />
                </div>
                <div className="team-content">
                  <h3>
                    <Link to={`/doi-ngu/${member.slug}`}>{member.name}</Link>
                  </h3>
                  <p>{member.position}</p>
                  <div className="social-icon">
                    {member.socials.facebook && (
                      <a
                        href={member.socials.facebook}
                        aria-label="facebook"
                      >
                        <FaFacebookF />
                      </a>
                    )}
                    {member.socials.twitter && (
                      <a
                        href={member.socials.twitter}
                        aria-label="twitter"
                      >
                        <FaTwitter />
                      </a>
                    )}
                    {member.socials.instagram && (
                      <a
                        href={member.socials.instagram}
                        aria-label="instagram"
                      >
                        <FaInstagram />
                      </a>
                    )}
                    {member.socials.linkedin && (
                      <a
                        href={member.socials.linkedin}
                        aria-label="linkedin"
                      >
                        <FaLinkedinIn />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div
          className="page-nav-wrap pt-5 text-center wow fadeInUp"
          data-wow-delay=".3s"
        >
          <ul>
            <li>
              <button
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
                className="page-numbers icon"
              >
                <FaArrowLeftLong />
              </button>
            </li>

            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i}>
                <button
                  onClick={() => setCurrentPage(i + 1)}
                  className={`page-numbers ${
                    currentPage === i + 1 ? "current" : ""
                  }`}
                >
                  {String(i + 1).padStart(2, "0")}
                </button>
              </li>
            ))}

            <li>
              <button
                onClick={() =>
                  setCurrentPage((p) => Math.min(p + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className="page-numbers icon"
              >
                <FaArrowRightLong />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
